// Static content for the "Terms of Trade" event page

export const EVENT = {
  slug: "terms-of-trade",
  kicker: "Panel Discussion",
  title: "Terms of Trade: India, Britain, and the Long Shadow of Empire",
  tagline:
    "India just signed a trade deal with Britain. Is this a partnership — or a familiar pattern?",
  description:
    "Examining the India-UK Free Trade Agreement through the lens of 200 years of colonial economic history. India's share of world GDP fell from 34% to 1.8% under British rule — the most documented economic collapse in modern history. Today, India negotiates trade terms with its former coloniser on near-equal economic footing. But terms still matter. Understanding what was extracted is the only way to know what a fair deal actually looks like.",
  date: "July 17, 2026",
  dateShort: { day: "17", month: "July", year: "2026" },
  time: "10:00 AM – 4:00 PM",
  venue: "Tamarind Hall, India Habitat Centre, Lodhi Road, Delhi-110003",
  mapUrl: "https://maps.app.goo.gl/sEXbYWHRw4rP5XyP7",
  banner: `${process.env.PUBLIC_URL}/event-banner.jpg`,
  liveThumb: `${process.env.PUBLIC_URL}/youtube-thumb.jpg`,
  registerUrl:
    "https://docs.google.com/forms/d/1vOHFVSSwDc6bBBFmFa4uneLVmggehXrIqWNtcAvgKRw/viewform",
  // YouTube live starts 10:00 AM IST on July 17, 2026
  liveStartIso: "2026-07-17T10:00:00+05:30",
};

export const MODERATOR = {
  name: "Richa Jain Kallra",
  role: "Founder - Wone Social · TV Host & News Anchor",
  image: `${process.env.PUBLIC_URL}/richa-kallra.jpg`,
};

export const SPEAKERS = [
  { name: "Dr. Charan Singh", role: "CEO, Founder & Director, EGROW Foundation", image: `${process.env.PUBLIC_URL}/charan-singh.png` },
  { name: "Prof. Abhijit Das", role: "International Trade Policy & WTO Expert", image: `${process.env.PUBLIC_URL}/abhijit-das.png` },
  { name: "Prasenjit K. Basu", role: "Economist & Historian. Author of 'India Reborn' & 'Asia Reborn'", image: `${process.env.PUBLIC_URL}/prasenjit-basu.png` },
  { name: "Prof. Prabhu Mohapatra", role: "Historian & Former HOD, History, Delhi University", image: `${process.env.PUBLIC_URL}/prabhu-mohapatra.jpg` },
  { name: "Colin Gonsalves", role: "Senior Advocate, Supreme Court & Founder, HRLN", image: `${process.env.PUBLIC_URL}/colin-gonsalves.jpg` },
  { name: "Chandini Jaswal", role: "Communications Team Member, The Museum of British Colonialism, UK-Kenya", image: `${process.env.PUBLIC_URL}/chandini-jaswal.jpg` },
];

export const PARTNERS = [
  { name: "The Museum of British Colonialism", logo: `${process.env.PUBLIC_URL}/mbc-logo.png` },
  { name: "India Pride Project", logo: `${process.env.PUBLIC_URL}/ipp-logo.jpg` },
];

export const COMMITTEE = [
  { name: "Dr. Sukhdev Singh", role: "Heritage Adviser & Former Vice Chairman, INTACH" },
  { name: "Mr. Gyaneshwar Dayal", role: "Associate Editor, The Pioneer" },
  { name: "Mr. Ramkumar Singaram", role: "Outreach & Communications, Catalyst PR" },
  { name: "Ms. Divya Bhatia", role: "Director, Urzu Media Solutions" },
];

export const SCHEDULE = [
  {
    time: "10:00 AM",
    title: "Registration Opens & Networking Tea",
    detail: "",
  },
  {
    time: "11:00 AM",
    title: "Opening Remarks by the Host",
    detail:
      "Welcome of distinguished speakers, dignitaries, media representatives and guests, followed by an introduction to the conference theme and programme announcements.",
  },
  {
    time: "11:15 AM",
    title: "Felicitation Ceremony",
    detail:
      "Recognition and felicitation of the Organising Committee, Knowledge Partners and Supporting Partners.",
  },
  {
    time: "11:20 AM",
    title: "Special Address by Mr. Vijay Kumar Sundaresan, Co-Founder, India Pride Project",
    detail:
      "Presentation on the work of the India Pride Project, its mission, and the historical context.",
  },
  {
    time: "11:35 AM",
    title: "Introduction of the Moderator & Distinguished Panelists",
    detail:
      "The Host will invite the Moderator to the stage, followed by the introduction of all Panel Speakers.",
  },
  {
    time: "11:40 AM",
    title: "Panel Discussion — Terms of Trade: India, Britain, and the Long Shadow of Empire",
    detail: "",
  },
  {
    time: "12:45 PM",
    title: "Closing Remarks",
    detail:
      "Delivered by the representative of Urzu Media Solutions Pvt. Ltd., summarising the key insights emerging from the discussion.",
  },
  {
    time: "12:50 PM",
    title: "National Initiative Announcement",
    detail:
      "Proposal to Observe 21 September as the National Day of Commemoration of Victims of Colonialism.",
  },
  {
    time: "12:55 PM",
    title: "Audience & Media Q&A Session",
    detail: "",
  },
  {
    time: "1:20 PM",
    title: "Networking Lunch",
    detail: "",
  },
];
